import React, { Component } from 'react'
import { FormControl } from 'react-bootstrap'
import { moneyFormatter } from '../../../utils/helpers'
import FontAwesome from 'react-fontawesome'

class EditableTD extends Component {
  constructor(props) {
    super(props)
    this.clickCount = 0
    this.state = {
      cellValue: typeof this.props.value !== 'undefined' ? this.props.value : 0,
      editable: false
      // selected: false
    }
  }

  onInputTextKeyPress(target) {
    if (target.charCode === 13) {
      this.props.onInputTextEnter(this.state.cellValue)
      this.setState({
        editable: false
      })
    }
  }

  onDoubleClick() {
    if (!this.state.editable) {
      // this.props.onDoubleClick()
      this.setState({
        editable: true
      })
    }

  }

  onTextChange(e) {
    this.setState({
      cellValue: (
        isNaN(e.target.value * 1) || e.target.value * 1 < 0
          ? 0
          : e.target.value * 1
      )
    })
  }

  singleClick() {
    if (!this.state.editable)
      this.props.onClick()
  }

  onClick() {
    this.clickCount++;
    let singleClickTimer = null
    if (this.clickCount === 1) {
      singleClickTimer = setTimeout(() => {
        this.clickCount = 0
        this.singleClick()
      }, 300)
    } else if (this.clickCount === 2) {
      clearTimeout(singleClickTimer)
      this.clickCount = 0
      this.onDoubleClick()
    }

  }

  handleClickOutside = evt => {
    this.setState({
      editable: false
    })
    this.props.onTDClickOutside(this.state.cellValue)
  }

  onInputTextBlur(e) {
    this.props.onInputTextBlur(e.target.value)
    this.setState({
      editable: false
    })
  }

  render() {
    const textInput = (
      <FormControl
        style={this.props.textInputStyle !== null ? this.props.textInputStyle : ''}
        value={this.state.cellValue}
        bsSize="sm"
        placeholder={this.props.value}
        onKeyPress={this.onInputTextKeyPress.bind(this)}
        onChange={this.onTextChange.bind(this)}
        onBlur={this.onInputTextBlur.bind(this)}
        autoFocus
      />
    )
    const textDisplay = (
      <span>
        {this.props.selected ? <FontAwesome name='check' /> : ''}
        {moneyFormatter.format(this.props.value)}
      </span>
    )

    const element = this.state.editable ? textInput : textDisplay
    return (
      <td
        // key={this.props.key}
        className={this.props.className}
        style={this.props.tdStyle}
        onClick={this.onClick.bind(this)}
      >
        <div style={this.props.textDivStyle}>
          {element}
        </div>
      </td>
    )
  }
}

EditableTD.defaultProps = {
  textDivStyle: '',
  tdStyle: ''
}

export default EditableTD



// WEBPACK FOOTER //
// ./src/view/workdoc/pricecompare/EditableTD.js